export default {
  apiKey: "AIzaSyCotR2t6QDcydcL_pJJAqXt0Qbl7nVw3Xw",
  authDomain: "greeter-prod.firebaseapp.com",
  projectId: "greeter-prod",
  storageBucket: "greeter-prod.appspot.com",
  messagingSenderId: "441705227727",
  appId: "1:441705227727:web:5cfe9f536da2266fe39eba",
  measurementId: "G-NZ6MKX1G2V",
};
